const translations = {
  "en": {
    "Add holdings failed": "Add holdings failed",
    "Ed already is.": "Ed already is.",
    "Ed got your feedback.": "Ed got your feedback.",
    "Flag risks before they hit": "Flag risks before they hit",
    "Full read on all stocks": "Full read on all stocks",
    "Someone should always be watching the market for you": "Someone should always be watching the market for you",
    "Track your holdings while you're away": "Track your holdings while you're away",
    "What should I know about this update?": "What should I know about this update?"
  },
  "zh-tw": {
    "Add holdings failed": "新增持股失敗",
    "Ed already is.": "Ed 已經是了。",
    "Ed got your feedback.": "Ed 已收到你的回饋。",
    "Flag risks before they hit": "在風險發生前預先警示",
    "Full read on all stocks": "完整解讀所有股票",
    "Someone should always be watching the market for you": "該有人一直幫你盯著市場",
    "Track your holdings while you're away": "在你離開時追蹤你的持倉",
    "What should I know about this update?": "我應該了解這個更新的什麼內容？"
  }
};

export default translations;
